import firebase from "gatsby-plugin-firebase"
import { dbUserSavedList } from "../database/dbreferences"
import firebaseObjectToArray from "../reuseableFunctions/firebaseObjectToArray"
// Expense Actions
export const setSavedList = savedList => ({
  type: "SET_SAVED_LIST",
  savedList: savedList,
})

export const startSavedList = uid => {
  return dispatch => {
    dbUserSavedList(uid).on("value", snapshot => {
      if (snapshot.val()) {
        dispatch(setSavedList(firebaseObjectToArray(snapshot.val())))
      }
      if (snapshot.val() === null) {
        dispatch(setSavedList(null))
      }
    })
  }
}
